import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import { lsStorageService } from '..';
import { lsStorageServiceConstants } from '../storage/storage';

// eslint-disable-next-line import/prefer-default-export
export const lsHeadersService = {
    getHeaders() {
        const headers = {
            'X-LS-CLIENT': process.env.VUE_APP_NAME,
            'X-LS-ClientVersionNumber': process.env.VUE_APP_VERSION,
        };

        const xAuthToken = lsStorageService.get(lsStorageServiceConstants.AUTH_TOKEN);
        if (xAuthToken) {
            _.set(headers, 'X-Auth-Token', xAuthToken);
        }

        // const engagementID = lsEngagementService.getEngagementID();
        // if (engagementID) {
        //     _.set(headers, 'X-LS-ENGAGEMENT-ID', engagementID);
        // }

        return headers;
    },
};
